import { useEffect, type ReactNode } from 'react';
import { useVisibleCopy } from '../i18n';

type DrawerProps = {
  title: string;
  open?: boolean;
  badge?: string;
  onClose?: () => void;
  closeLabel?: string;
  closeDisabled?: boolean;
  children: ReactNode;
};

export function Drawer({
  title,
  open = false,
  badge = 'live',
  onClose,
  closeLabel = 'Close',
  closeDisabled = false,
  children,
}: DrawerProps) {
  const ui = useVisibleCopy();

  useEffect(() => {
    if (!open || !onClose || closeDisabled) return undefined;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [closeDisabled, onClose, open]);

  if (!open) return null;
  return (
    <>
      <div className="drawer-backdrop" aria-hidden="true" onClick={closeDisabled ? undefined : onClose} />
      <aside className="sheet-drawer" role="dialog" aria-modal="true" aria-label={ui(title)}>
        <div className="sheet-drawer-header">
          <h2>{ui(title)}</h2>
          <div className="drawer-actions">
            <span className="badge">{ui(badge)}</span>
            {onClose ? <button className="btn btn-compact" type="button" onClick={onClose} disabled={closeDisabled}>{ui(closeLabel)}</button> : null}
          </div>
        </div>
        <div className="sheet-drawer-body">
          {children}
        </div>
      </aside>
    </>
  );
}
